import { ExtendableError } from "@/core/error"

class UserAlreadyExistsError extends ExtendableError {}
class UserNotFoundError extends ExtendableError {}
class UserUnAuthorizedError extends ExtendableError {}
class UserUnVerifiedError extends ExtendableError {}
class InvalidEmail extends ExtendableError {}
class WeakPasswordError extends ExtendableError {}
class HasRelationsError extends ExtendableError {}


export {
  UserAlreadyExistsError,
  UserNotFoundError,
  UserUnAuthorizedError,
  UserUnVerifiedError,
  InvalidEmail,
  WeakPasswordError,
  HasRelationsError
}